import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoImg from "../../../images/dash-logo.svg";

export function NavMenuToggle() {
	setTimeout(() => {
		let mainwrapper = document.querySelector("#main-wrapper");
		if (mainwrapper?.classList?.contains("menu-toggle")) {
			mainwrapper?.classList?.remove("menu-toggle");
		} else {
			mainwrapper?.classList?.add("menu-toggle");
		}
	}, 200);
}

const NavHader = ({ toggle, setToggle }) => {
	return (
		<div className="nav-header">
			<div
				className="nav-control p-0"
				onClick={() => {
					setToggle((prev) => !prev);
					// NavMenuToggle();
				}}>
				<div className={`${toggle ? "is-active" : ""}`}>
					<i className="la la-angle-double-left"></i>
				</div>
			</div>
		</div>
	);
};

export default NavHader;
